export default __webpack_public_path__ + "static/media/screenBlock11.f0593633.jpg";